import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import Button from '@repo/ui/button'
import { PrintIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { API, constructApiUrl } from '../../../api/apis.config'
import { getCenter } from '../../../api/centers/get-center'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import PeriodBadge from '../../../components/elements/period-badge'
import { useDownloadDocuments } from '../../../lib/hooks/use-download-documents'
import { CenterProperties } from '../../../lib/types/models/center/properties.center'
import CenterAffectedStudents from './center-affected-students'
import CenterBlockedStudents from './center-blocked-students'

const CenterStudents = () => {
  const { id } = useParams<{ id: string }>()
  const { downloadDocuments } = useDownloadDocuments()

  const { data, refetch } = useQuery({
    queryKey: ['centers', id],
    queryFn: () => {
      if (!id || isNaN(parseInt(id))) return
      return getCenter(parseInt(id))
    },
    enabled: !!id
  })

  if (!id || isNaN(parseInt(id))) return null
  if (!data) return <LoadingScreen />

  return (
    <div>
      <div className="h-5" />
      <div className="flex gap-2 items-center flex-wrap">
        <Typography variant="tag" color={tailwindColors.grey.lighter}>
          Séjours attribués :
        </Typography>

        {CenterProperties.getCenterJourneyInformation(data).map(({ period, title }) => (
          <PeriodBadge key={id} size={'medium'} period={period} text={title} />
        ))}
      </div>
      <div className="h-5" />
      <div className="flex gap-2 items-center flex-wrap">
        <Badge variant="warning" text={`Total # max de jeunes : ${data.maxNumberOfPlaces}`} />
        <Badge variant="warning" text={`Total affectés : ${data.affectedStudentsNumber}`} />
        <Badge variant="warning" text={`Total bloqués : ${data.blockedPlacesNumber}`} />

        <Button
          type="button"
          icon={PrintIcon}
          variant="ghost"
          label="Liste d'appel"
          onClick={() => {
            downloadDocuments({
              endpoint: constructApiUrl(API.centers.printCallList.url, { id })
            })
          }}
        />
      </div>

      <div className="h-5" />
      <CenterAffectedStudents
        centerId={+id}
        onReserveBlockedPlace={refetch}
        onUnblockStudent={refetch}
      />
      <div className="h-5" />
      <CenterBlockedStudents
        centerId={+id}
        onUnblockStudent={refetch}
        onReserveBlockedPlace={refetch}
      />
    </div>
  )
}

export default CenterStudents
